import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import LoadingWrapper from "../../common/loading-wrapper";
import { Table } from "antd";
import { countPatentsByField } from "../../../services/api-patents";
import { toTitleCase } from "../../../helpers/converters";
import { withTableConfig } from "../../common/table-config-hoc";

const LawFirmTable = ({ filter, size = 30, style = {} }) => {
  const [state, setState] = useState({
    data: [],
    loading: true,
    error: false
  });

  const _updateTable = () =>
    countPatentsByField(filter, "law_firm", size)
      .then(json => {
        setState({
          data: json,
          loading: false
        });
      })
      .catch(() => {
        setState({
          loading: false,
          error: true
        });
      }
    );

  useEffect(() => {
    _updateTable();
  }, [filter, size]);

  const columns = [
    {
      dataIndex: "key",
      title: "Law Firm",
      render: toTitleCase
    },
    {
      dataIndex: "doc_count",
      title: "#Patents"
    },
    {
      dataIndex: "rank",
      title: "Rank",
      render: (text, record, index) => index + 1
    }
  ];

  const WrappedTable = withTableConfig(Table, { dataSource: state.data });

  return (
    <LoadingWrapper loading={state.loading} error={state.error} style={{ textAlign: "center", ...style }}>
      <WrappedTable dataSource={state.data} title={`Top ${size} Law Firms`} columns={columns} rowKey={"key"} pagination={false} size="small" />
    </LoadingWrapper>
  );
}

LawFirmTable.propTypes = {
  filter: PropTypes.object,
  size: PropTypes.number,
  style: PropTypes.object
};

export default LawFirmTable;
